// polyfill for add .placeholder-shown class instead of use :placeholder-shown pseudo
let placeholders = [...document.querySelectorAll('[placeholder]')];

function placeholderPolyfill() {
    this.classList[this.value ? 'remove' : 'add']('placeholder-shown');
}

placeholders.forEach(el => {
    el.addEventListener('change', placeholderPolyfill);
    el.addEventListener('keyup', placeholderPolyfill);

    if(el.value.length < 1) {
        el.classList.add('placeholder-shown');
    }
});
